module.exports = __webpack_public_path__ + "img/grant.6f032690.svg";